import { PublicLayout } from "@/components/layout/PublicLayout";
import { ShieldCheck, Lock, FileCheck2, Dog } from "lucide-react";

const values = [
  {
    icon: ShieldCheck,
    title: "Results first",
    body: "Proven, structured programs built around your dog's temperament and your goals.",
  },
  {
    icon: Lock,
    title: "Private by default",
    body: "Your details are stored in a private database, accessible only to the Clawius team.",
  },
  {
    icon: FileCheck2,
    title: "Clear consent",
    body: "Consent is recorded with a timestamp and the exact language you agreed to — nothing hidden.",
  },
  {
    icon: Dog,
    title: "One dog, one record",
    body: "Every enrollment is a single, accurate record — no duplicates, no confusion.",
  },
];

export default function About() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 py-20 md:py-28 lg:px-8" data-testid="about-page">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <div>
            <p className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-primary">
              About Clawius
            </p>
            <h1 className="mt-3 font-display text-5xl uppercase leading-none tracking-wide text-white sm:text-6xl">
              Training that sticks.
            </h1>
            <p className="mt-6 font-body leading-relaxed text-zinc-400">
              Clawius is a focused dog-training service. Owners enroll their dog
              through one clean form that captures the essentials — your contact
              details, your dog, and your consent — and nothing more.
            </p>
            <p className="mt-4 font-body leading-relaxed text-zinc-400">
              We keep the intake tight and the records clean. Every enrollment is
              backed by clear, timestamped consent so both sides always know
              exactly what was agreed to.
            </p>
          </div>
          <div className="overflow-hidden rounded-sm border border-border">
            <img
              src="https://images.pexels.com/photos/13918163/pexels-photo-13918163.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Trainer working with a German Shepherd outdoors"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div className="mt-20 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-sm border border-border bg-card p-6 transition-all duration-200 hover:-translate-y-1 hover:border-primary"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-primary/15 text-primary">
                <v.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold tracking-tight text-white">
                {v.title}
              </h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-zinc-400">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
